import { createRoot } from 'react-dom/client';
import { REGISTRY } from './registry';

// Boot once: scan the DOM for island placeholders Drupal rendered and mount
// the matching component into each. Drupal already produced the SEO HTML
// around them; React only enhances the interactive bits.
const settings = (window as any).drupalSettings?.reciklart ?? {};

document.querySelectorAll<HTMLElement>('[data-react]').forEach((el) => {
  const name = el.dataset.react;
  if (!name) return;
  const Component = REGISTRY[name];
  if (!Component) {
    // eslint-disable-next-line no-console
    console.warn(`[reciklart] no island registered for "${name}"`);
    return;
  }
  createRoot(el).render(<Component dataset={{ ...el.dataset }} settings={settings} />);
});
